export const CONTROL_FOCUS_CLASS =
  "focus-visible:border-focus focus-visible:hover:border-focus focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-inset focus-visible:ring-focus";

export const CONTROL_GROUP_FOCUS_CLASS =
  "focus-within:border-focus focus-within:hover:border-focus focus-within:ring-1 focus-within:ring-inset focus-within:ring-focus";

export const CONTROL_OPEN_CLASS =
  "data-[state=open]:border-focus data-[state=open]:hover:border-focus data-[state=open]:ring-1 data-[state=open]:ring-inset data-[state=open]:ring-focus";
